import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Typography } from 'antd';
import { ROUTES } from '@shared/config/routes';
import { LoginForm } from '@features/auth';
import { AuthLayout } from '@widgets/auth-layout';

const { Text } = Typography;

export function LoginPage() {
  const { t } = useTranslation();
  return (
    <AuthLayout title={t('auth.login.title')} subtitle={t('auth.login.subtitle')}>
      <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
        <LoginForm />
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 6 }}>
          <Link to={ROUTES.forgotPassword} style={{ fontSize: 13 }}>
            {t('auth.login.forgotPassword')}
          </Link>
          <Text type="secondary" style={{ fontSize: 13 }}>
            {t('auth.login.noAccount')}{' '}
            <Link to={ROUTES.register}>{t('auth.login.registerLink')}</Link>
          </Text>
        </div>
      </div>
    </AuthLayout>
  );
}
